export const featuredTopics = [
  {
    id: "fx-01",
    tag: "舆情复盘",
    title: "一场直播翻车：从全场刷屏到集体退单，只用了一个晚上",
    summary:
      "镜头前的话术、后台的库存改动、加上一条被秒删的连麦，三条线索拼起来，才发现翻车并不是意外。",
    source: "看点复盘组",
    time: "2 小时前",
    heat: 9621,
    comments: 486,
    image:
      "https://readdy.ai/api/search-image?query=warm%20amber%20lit%20abstract%20scene%20of%20a%20crowd%20seen%20from%20above%20in%20a%20dim%20hall%2C%20motion%20blur%2C%20charcoal%20and%20amber%20tones%2C%20cinematic%20soft%20haze%2C%20simple%20uncluttered%20background%2C%20artistic%20conceptual%20photography%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=hlkd-spot-01&orientation=landscape",
  },
  {
    id: "fx-02",
    tag: "商业观察",
    title: "被改了三版的招股书里，藏着一个不敢明说的增长焦虑",
    summary:
      "同一组数据换了三次口径，我们把三个版本逐条对齐，真正的问题其实写在脚注里。",
    source: "看点商业组",
    time: "今天 09:40",
    heat: 8744,
    comments: 312,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20close%20up%20of%20a%20magnifying%20glass%20resting%20on%20warm%20beige%20papers%20with%20soft%20amber%20light%2C%20charcoal%20shadows%2C%20clean%20simple%20background%2C%20cinematic%20soft%20haze%2C%20artistic%20conceptual%20photography%2C%20no%20text%2C%20high%20detail&width=800&height=600&seq=hlkd-spot-02&orientation=landscape",
  },
  {
    id: "fx-03",
    tag: "细节考据",
    title: "时间线对不上的那 17 分钟，才是整件事最关键的缺口",
    summary:
      "目击描述、平台日志和一段背景音，三个来源互相打架，我们把它们摆在了同一条时间轴上。",
    source: "看点考据组",
    time: "昨天 22:15",
    heat: 7930,
    comments: 275,
    image:
      "https://readdy.ai/api/search-image?query=abstract%20tangled%20red%20and%20amber%20threads%20forming%20a%20web%20on%20a%20warm%20cream%20surface%2C%20soft%20directional%20light%2C%20charcoal%20shadows%2C%20simple%20uncluttered%20background%2C%20cinematic%20haze%2C%20artistic%20conceptual%20photography%2C%20no%20text&width=800&height=600&seq=hlkd-spot-03&orientation=landscape",
  },
];